// CalendarViewToggle — переключатель вида календаря «Месяц/Неделя/День» (M3, §7/§8).
// Тонкая Presentational-обёртка MUI ToggleButtonGroup (exclusive) = MD3 сегментированный выбор;
// state вида живёт в useCalendarView — компонент только отображает и сообщает.
import { ToggleButtonGroup, ToggleButton } from '@mui/material';
import type { CalendarViewMode } from '../hooks/useCalendarView';

interface CalendarViewToggleProps {
  /** Текущий вид. */
  value: CalendarViewMode;
  /** Колбэк при переключении вида (из useCalendarView.setViewMode). */
  onChange: (view: CalendarViewMode) => void;
}

/** Переключатель вида календаря (M3, aria-label для доступности). */
export function CalendarViewToggle({ value, onChange }: CalendarViewToggleProps): JSX.Element {
  return (
    <ToggleButtonGroup
      data-testid="calendar-view-toggle"
      aria-label="Вид календаря"
      value={value}
      exclusive
      size="small"
      onChange={(_, next: CalendarViewMode | null) => {
        if (next) onChange(next);
      }}
    >
      <ToggleButton value="month">Месяц</ToggleButton>
      <ToggleButton value="week">Неделя</ToggleButton>
      <ToggleButton value="day">День</ToggleButton>
    </ToggleButtonGroup>
  );
}
